import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { GenFormBuilder } from '../../../../providers/form';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoadingController, ToastController } from 'ionic-angular';
import { VotingData } from '../../../../providers/voting';
import { take } from 'rxjs/operators';
import { ENV } from '@app/env';
import { isEmpty } from 'lodash';
import { UtilitiesProvider } from '../../../../providers/utilities';
import { TranslateCodePipe } from '../../../../pipes/translate';

@Component({
  selector: 'app-voting-code',
  templateUrl: 'voting-code.html'
})

export class VotingCodeComponent implements OnInit {

  public form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private genForm: GenFormBuilder,
    private loadingCtrl: LoadingController,
    private votingData: VotingData,
    private toastCtrl: ToastController,
    private utilities: UtilitiesProvider,
    private translatePipe: TranslateCodePipe
  ) { }

  @Input('eventId')
  public eventId: string;

  @Input('votingId')
  public votingId: string;

  @Input('userId')
  public userId: string;

  @Output('changeView')
  public changeView: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.checkUserHasAcodeRegistered();
    this.buildForm();
  }

  public checkUserHasAcodeRegistered() {
    return this.votingData.hasPonderationRegisterByUserId(ENV.client, this.eventId, this.votingId, this.userId)
      .subscribe((data: any) => {
        if (data) {
          this.utilities.consoleDecorator('checkUserHasAcodeRegistered', data);
          if (!isEmpty(data)) {
            this.changeView.emit(
              data.code
            );
          }
        }
      })
  }

  public buildForm() {
    this.form = this.fb.group({});
    this.genForm.genInputNumber('code', this.form, true);
  }

  public async validateCode({ value, valid }: { value: any, valid: boolean }) {
    if (valid) {
      let loader = this.loadingCtrl.create({
        content: await this.translatePipe.transform('Validating code'),
      });
      loader.present();

      this.votingData.validateVotingCode(this.eventId, this.votingId, this.userId, value.code)
        .pipe(take(1))
        .subscribe((data) => {
          this.utilities.consoleDecorator('validateVotingCode', data);
          this.showValidateVotingCodeResult(data);
          loader.dismiss();
        })
    }
  }

  public showValidateVotingCodeResult(data) {
    switch (data.status) {
      case 'invalid':
      case 'undefined':
        this.toastCtrl.create({
          message: data.message,
          duration: 3000
        }).present();
        break;
      case 'valid':
        this.toastCtrl.create({
          message: data.message,
          duration: 3000
        }).present();
        this.changeToVoting();
        break;
    }
  }

  public changeToVoting() {
    this.changeView.emit(
      this.form.get('code').value
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/voting/components/voting-code/voting-code.ts